import FILE_TYPE_ICONS  from "assets/icons/file_type_icons";

import GOOGLE_DOCUMENT_ICON from "assets/img/google_drive/documents.png";
import GOOGLE_FORMS_ICON from "assets/img/google_drive/forms.png";
import GOOGLE_PRESENTATION_ICON from "assets/img/google_drive/presentations.png";
import GOOGLE_SPREADSHEET_ICON from "assets/img/google_drive/spreadsheets.png";

// TODO any reference to `item` in this file should be updated from `any` to correct type once known
interface GoogleFile {
  prefix: string,
  metadata: GoogleFileMetadata,
  enhance(item: any): any
}

// TODO update the `unknown` to be correct file types
interface GoogleFileMetadata {
  documentType: string,
  favIconUrl: unknown,
  fileTypeIcon: unknown,
  fileType: string
}

// Shared constants
export const GOOGLE_EDIT_MATCH = /https:\/\/docs\.google\.com\/(document|spreadsheets|presentation|forms)\/d\/[^/]+\/edit/;

// Google Document specific constants 
export const GOOGLE_DOCUMENT_CREATE = "https://doc.new";
export const GOOGLE_DOCUMENT_PREFIX = "https://docs.google.com/document/d/";
export { GOOGLE_DOCUMENT_ICON };

// Google Forms specific constants 
export const GOOGLE_FORMS_CREATE = "https://docs.google.com/forms/create";
export const GOOGLE_FORMS_PREFIX = "https://docs.google.com/forms/d/";
export { GOOGLE_FORMS_ICON };

// Google Presentation specific constants 
export const GOOGLE_PRESENTATION_CREATE = "https://slide.new";
export const GOOGLE_PRESENTATION_PREFIX = "https://docs.google.com/presentation/d/";
export { GOOGLE_PRESENTATION_ICON };

// Google Spreadsheet specific constants 
export const GOOGLE_SPREADSHEET_CREATE = "https://sheet.new";
export const GOOGLE_SPREADSHEET_PREFIX = "https://docs.google.com/spreadsheets/d/";
export { GOOGLE_SPREADSHEET_ICON };

// Shared functions to enhance untitled files
function googleUntitledDocumentEnhancement(item : any) {
  let title = item.title;
  const match = GOOGLE_EDIT_MATCH.exec(item.url);

  if (!title && match) {
    if (match[1] === "spreadsheets") {
      title = "Untitled spreadsheet";
    } else if (match[1] === "forms") {
      title = "Untitled form";
    } else {
      title = `Untitled ${match ? match[1] : "document"}`;
    }
  }

  return {
    ...item,
    title
  };
}

// Shared functions to create file stub
function createGoogleFileStub(prefix : string, documentType : string, favIconUrl : any, fileTypeIcon : any, fileType : string) : GoogleFile {
  return {
    prefix: prefix,
    metadata: {
      documentType: documentType,
      favIconUrl: favIconUrl,
      fileTypeIcon: fileTypeIcon,
      fileType: fileType
    },
    enhance(item) {
      return googleUntitledDocumentEnhancement(item);
    }
  }
};

// Create Google Document stub 
export const GoogleDocument = createGoogleFileStub(GOOGLE_DOCUMENT_PREFIX, "Google Document", GOOGLE_DOCUMENT_ICON, FILE_TYPE_ICONS.google_word, "document");

// Create Google Forms stub
export const GoogleForms = createGoogleFileStub(GOOGLE_FORMS_PREFIX, "Google Form", GOOGLE_FORMS_ICON, FILE_TYPE_ICONS.google_form, "form");

// Create Google Presentation stub
export const GooglePresentation = createGoogleFileStub(GOOGLE_PRESENTATION_PREFIX, "Google Presentation", GOOGLE_PRESENTATION_ICON, FILE_TYPE_ICONS.google_powerpoint, "presentation");

// Create Google Spreadsheet stub
export const GoogleSpreadsheet = createGoogleFileStub(GOOGLE_SPREADSHEET_PREFIX, "Google Spreadsheet", GOOGLE_SPREADSHEET_ICON, FILE_TYPE_ICONS.google_excel, "spreadsheet");
